function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1534 145",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.55556,0,0,5.55556,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.7423,0,0,1.7423,-217.517,-52.0749)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M125,44.5L125,30.1L128.3,30.1L128.3,41.8L139.1,41.8L139.1,44.5L125,44.5Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 30.1,
    width: 3.3,
    height: 14.4,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.6,32.7L155.6,41.8L166,41.8L166,38.6L160.6,38.6L160.6,36.2L169.3,36.2L169.3,41.2C169.3,42.5 169.1,43.4 168.5,43.9C168,44.4 167.1,44.6 165.7,44.6L155.8,44.6C154.4,44.6 153.5,44.4 153,43.9C152.5,43.4 152.2,42.5 152.2,41.2L152.2,33.6C152.2,32.3 152.5,31.4 153,30.9C153.5,30.4 154.4,30.2 155.8,30.2L165.7,30.2C169.3,30.2 169.2,31.5 169.2,32.8L155.6,32.7Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.2,44.5L174.2,30.1L177.5,30.1L177.5,35.7L187.9,35.7L187.9,30.1L191.3,30.1L191.3,44.5L187.9,44.5L187.9,38.3L177.5,38.3L177.5,44.5L174.2,44.5Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,32.7L206,44.5L202.7,44.5L202.7,32.7L196.1,32.7L196.1,30.1L212.6,30.1L212.6,32.7L206,32.7Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.3,44.5L237.3,30.1L240.6,30.1L240.6,35.7L251,35.7L251,30.1L254.4,30.1L254.4,44.5L251,44.5L251,38.3L240.6,38.3L240.6,44.5L237.3,44.5Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.3,
    y: 30.1,
    width: 3.3,
    height: 14.4,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.6,44.5L267.6,30.1L279.9,30.1C282,30.1 283.1,31 283.1,32.9L283.1,36.1C283.1,38 282,38.9 279.9,38.9L270.9,38.9L270.9,44.5L267.6,44.5ZM278.4,32.6L270.9,32.6L270.9,36.5L278.4,36.5C278.9,36.5 279.3,36.4 279.5,36.3C279.8,36.1 279.9,35.8 279.9,35.3L279.9,33.7C279.9,33.2 279.8,32.9 279.5,32.7C279.2,32.6 278.9,32.6 278.4,32.6",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.5,30.1C219.1,30.1 218.2,30.3 217.7,30.8C217.2,31.3 217,32.2 217,33.5L217,35.1C217,36.4 217.2,37.3 217.7,37.8C218.2,38.3 219.1,38.5 220.5,38.5L229.5,38.5L229.5,41.8L217,41.8C217,43.1 217,44.5 220.6,44.5L228.9,44.5C230.3,44.5 231.2,44.3 231.7,43.8C232.2,43.3 232.5,42.4 232.5,41.1L232.5,39.1C232.5,37.8 232.2,36.9 231.7,36.4C231.2,35.9 230.2,35.7 228.9,35.7L219.9,35.7L219.9,32.8L232.5,32.8C232.5,31.5 232.5,30.1 228.9,30.1L220.5,30.1Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.320b9af4c5240fccdd73dc50f0e4e961.svg";
export { ForwardRef as ReactComponent };